import React from "react";

const BodyText = ({body}) => {
  return <div className="body-text" dangerouslySetInnerHTML={{ __html: body }} />
}

export default BodyText
